import { Icon } from 'components/Icon'
import { Picture } from 'components/Picture'

import * as S from './styled'

type IndustrySIFType = {
  error: string
  industrySIFPhoto: { src: string; filename: string }
  onLoadImage: (_key) => void
  onRemoveImage: (_key) => void
  documentType?: string
}

export function IndustrySIF({
  error,
  industrySIFPhoto,
  onLoadImage,
  onRemoveImage,
  documentType
}: IndustrySIFType) {
  return (
    <S.GridPhoto item sm={12} md={4}>
      <S.DividerVertical orientation="vertical" />
      <S.DivPhotoMessage>
        <S.CardPhoto>
          {documentType === 'internacional' ? (
            // Para empresas internacionais, mostrar apenas a imagem sem botões
            <div style={{ textAlign: 'center' }}>
              <img
                src={industrySIFPhoto?.src || '/images/default-image.png'}
                alt="SIF Photo"
                style={{
                  width: '200px',
                  height: '200px',
                  objectFit: 'contain',
                  border: '1px solid #d9d9d9',
                  borderRadius: '4px'
                }}
              />
            </div>
          ) : (
            <Picture
              name="industrySIFPhoto"
              onLoadImage={onLoadImage}
              imgUrl={industrySIFPhoto ? industrySIFPhoto.src : ''}
              variant="square"
              onRemoveImage={onRemoveImage}
            />
          )}
        </S.CardPhoto>
        {error && (
          <S.AlertIcon>
            <Icon icon="itens-interface-alert" height={10} width={10} />
            <p>{error}</p>
          </S.AlertIcon>
        )}
      </S.DivPhotoMessage>
    </S.GridPhoto>
  )
}
